// extracted by mini-css-extract-plugin
export var parcelRow = "_v1-0";